module.exports = __webpack_public_path__ + "img/Nav_decline_grp.19b899a4.svg";